import { Link } from '@ktag/styleguide/dist/react';
import { JobPortalScreen } from 'jobs.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  setScreen?: (screen: JobPortalScreen) => void;
  loginUrl: string;
}

const JobListLinks = ({ setScreen, loginUrl }: Props) => {
  const { t } = useTranslation('jobs');
  return (
    <div className="joblistlinks">
      <Link
        href={loginUrl}
        additionalClassNames="jobportallinks__login"
        icon={{ id: 'internal' }}
        text={t('jobportallinks_login')}
      />
      <Link
        as="button"
        additionalClassNames="joblistlinks__abo"
        icon={{ id: 'email' }}
        text={t('jobportallinks_abo')}
        onClick={() => setScreen('jobabo')}
      />
    </div>
  );
};

export default JobListLinks;
